import { formatDateTime } from "../../sUtils/dateUtils";

function ViewingWorkEventModal({
  isOpen,
  onClose,
  selectedEvent,
  setIsEditWorkEventModalOpen,
  setIsViewingWorkEventModalOpen,
  handleDeleteWorkEvent,
}) {
  if (!isOpen || !selectedEvent) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-xl shadow-xl max-w-md w-full font-sans relative">

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
        >
          ✕
        </button>

        <h2 className="text-xl font-bold mb-4">
          {selectedEvent.title}
        </h2>

        <p><b>Job Number:</b> {selectedEvent.job_number}</p>
        <p><b>Date:</b> {formatDateTime(selectedEvent.start)}</p>
        <p><b>Primary Technician:</b> {selectedEvent.primary_technician}</p>
        <p><b>Additional Technicians:</b> {selectedEvent.additional_technicians}</p>
        <p><b>Property:</b> {selectedEvent.property}</p>
        <p><b>Street Address:</b> {selectedEvent.address_line}</p>
        <p><b>City:</b> {selectedEvent.city}</p>
        <p><b>State:</b> {selectedEvent.state}</p>
        <p><b>Zip Code:</b> {selectedEvent.zipcode}</p>

        <div className="mt-4 flex justify-end gap-3">
          <button
            onClick={() => {
              // Open the edit modal for this work event
              setIsEditWorkEventModalOpen(true);
              // Close the viewing modal
              setIsViewingWorkEventModalOpen(false);
            }}
            className="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600"
          >
            Edit
          </button>

          <button
            onClick={() => handleDeleteWorkEvent(onClose)}
            className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewingWorkEventModal;